module.exports = __webpack_public_path__ + "static/media/winterscene.34a55aa1.jpg";